<template>
  <div :id="$route.params.page">
    <div class="grad"></div>
    <transition name="fade">
      <div
        v-if="loaded"
        id="theBackground"
        class="fullPageBackground"
        v-bind:style="{ 'background-image': 'url(' + single.IMAGE + ')' }"
      >
        <div class="fullPageContent" :class="$route.params.page">
          <transition name="slide-fade">
            <div v-html="single.POST_CONTENT" v-if="contentLoaded"></div>
          </transition>
        </div>
      </div>
    </transition>
    <lightbox :value="showLightbox" :images="lightboxImages" class="light">
      <template v-slot:content="{ url: { link, alt } }">
        <img :src="link" :alt="alt" />
        <p class="imgAlt">{{alt}}</p>
      </template>
      <lightbox-default-loader slot="loader"></lightbox-default-loader>
    </lightbox>
    <div v-if="!loaded" class="theLoader">
      <span class="loader">
        <span class="loader-inner"></span>
      </span>
    </div>
  </div>
</template>

<script>
import Vue from "vue";
import { mapGetters, mapActions } from "vuex";
const fetchInitialData = (store, route) => {
  return store.dispatch(`page/getPage`, route.params.page);
};
export default {
  data() {
    return {
      contentLoaded: false,
      loaded: false,
      lightboxImages: [],
      showLightbox: false
    };
  },
  computed: {
    ...mapGetters("page", ["single", "pageIsLoading"]),
    single() {
      return this.$store.state.page.single;
    }
  },
  methods: {
    ...mapActions("page", {
      getPage: "getPage"
    }),
    loadData() {
      fetchInitialData(this.$store, this.$route);
    },
    createLightbox(imagesList, titlesList) {
      var self = this;
      Vue.nextTick(() => {
        self.showLightbox = false;
        Vue.nextTick(() => {
          self.lightboxImages = [
            {
              link: imagesList,
              alt: titlesList
            }
          ];
          self.showLightbox = true;
        });
      });
    }
  },
  watch: {
    $route(to, from) {
      this.loaded = false;
      this.contentLoaded = false;
      this.loadData();
    },
    single: function(newContent) {
      var self = this;
      var img = new Image();
      img.onload = function() {
        setTimeout(function() {
          self.loaded = true;
        }, 150);

        setTimeout(function() {
          self.contentLoaded = true;
        }, 250);
      };
      if (this.$route.params.page == "polityka-prywatnosci") {
        self.loaded = true;
        self.contentLoaded = true;
      }
      img.src = newContent.IMAGE;
      if (img.complete) img.onload();
    }
  },
  prefetch: fetchInitialData,
  mounted() {
    var self = this;
    if (document.getElementById("pracownia") !== null) {
      document
        .querySelector("#pracownia")
        .addEventListener("click", function(event) {
          if (event.target.tagName.toLowerCase() === "a") {
            event.preventDefault();
            self.createLightbox(
              event.target.getAttribute("href"),
              event.target.textContent
            );
          }
        });
    }
    this.loadData();
    const element = document.getElementById("page");
    element.classList.add("addAnimation");
  },
  beforeCreate: function() {
    document.body.classList.add("invertedHeader");
    document.body.classList.add("redBackground");
  },
  beforeDestroy: function() {}
};
</script>